import React, { useEffect, useState } from "react"
import { ReactComponent as Vector1 } from "../../assets/images/Group 1.svg"
import { ReactComponent as Vector3 } from "../../assets/images/Group 1 (3).svg"
import { ReactComponent as Vector4 } from "../../assets/images/Group 1 (4).svg"
import { ReactComponent as ApprovedIcon } from "../../assets/images/approvedIcon.svg"
import { AgCharts } from "ag-charts-react"
import { NumericFormat } from "react-number-format"
import axiosInstance from "../../services/axiosInstance"
import Loader from "../../components/Loader"
import SessionExpired from "./sessionExpired"
import { useNavigate } from "react-router-dom"
import TableCommponnent from "../../components/TableCommponnent"
import Header from "../apprLyout/Topnav"
import Sidenav from "../apprLyout/Sidenav"
const Homepage = () => {
  const [page, setPage] = useState(1)
  const [size, setSize] = useState(10)
  const [total, setTotal] = useState("")
  const [count, setCount] = useState("")
  const [loading, setLoading] = useState(false)
  const [pendingInvoices, setPendingInvoices] = useState([])
  const [completedInvoices, setCompletedInvoices] = useState([]) // Only for chart data
  // Simplified to 3 counts only
  const [allInvoicesCount, setAllInvoicesCount] = useState(0)
  const [pendingInvoicesCount, setPendingInvoicesCount] = useState(0)
  const [completedInvoicesCount, setCompletedInvoicesCount] = useState(0)
  const [rejectedInvoicesCount, setRejectedInvoicesCount] = useState(0)
  const [acceptedInvoicesCount, setAcceptedInvoicesCount] = useState(0)
  const [error, setError] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const navigate = useNavigate()
  const token = localStorage.getItem("accessToken")
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        const roles = JSON.parse(localStorage.getItem("roles")) || []

        // OPTIMIZED: Fetch only 3 counts (All, Pending, Completed)
        // Use single summary endpoint to retrieve required dashboard data
        const summaryResponse = await axiosInstance.get("/approvals/v1/summary/invoice")

        const {
          total_count = 0,
          pending_count = 0,
          completed_count = 0,
          rejected_count = 0,
          accepted_count = 0,
          recent_pending_signables = [],
        } = summaryResponse.data.data || {}

        // Update counts
        setAllInvoicesCount(total_count)
        setPendingInvoicesCount(pending_count)
        setCompletedInvoicesCount(completed_count)
        setRejectedInvoicesCount(rejected_count)
        setAcceptedInvoicesCount(accepted_count)

        // Pending invoices (used in the recent table)
        setPendingInvoices(recent_pending_signables)
        setCount(pending_count)
        setTotal(Math.ceil(pending_count / size))

        // Cache dashboard counts
        localStorage.setItem(
          "dashboardCounts",
          JSON.stringify({
            all: total_count,
            pending: pending_count,
            completed: completed_count,
            rejected: rejected_count,
            accepted: accepted_count,
          }),
        )
      } catch (error) {
        if (token && error?.response?.status === 401) {
          setRefresh(true)
        } else {
          handleError(error)
        }
      } finally {
        setLoading(false)
      }
    }

    fetchData()
  }, [token, page, size]) // Added page, size dependencies

  const handleButtonClick = item => {
    console.log(item)
  }
  const handleError = error => {
    console.error("Invoice fetching error:", error)
    const errorMessage = error?.response?.data?.detail || "Error Fetching Invoice Data"

    if (error?.response?.status === 401) {
      setRefresh(true)
      // handleLogout(msalConfig, userName, navigate); // Uncomment if needed
    } else {
      setError(errorMessage)
    }
  }

  // Convert the grouped data object to an array
  const groupedData = [...completedInvoices]
    .reverse()
    // Only include approved items with a date_signed
    .map(item => ({
      ...item,
      month: new Date(item.workflow.signatures[0].date_signed).toLocaleString("default", {
        month: "short",
      }), // Format month without year
    }))
    .reduce((acc, item) => {
      const month = item.month
      if (!acc[month]) {
        acc[month] = { month, invoice_count: 0 }
      }
      acc[month].invoice_count += 1 // Increment the count for the month
      return acc
    }, {})

  // Convert the grouped data object to an array
  const chartData = Object.values(groupedData)

  // Create an array of all months till the current month
  const allMonths = []
  const currentDate = new Date()
  for (let m = 0; m <= currentDate.getMonth(); m++) {
    const monthName = new Date(0, m).toLocaleString("default", {
      month: "short",
    })
    allMonths.push({ month: monthName, invoice_count: 0 })
  }

  // Fill in the chartData with invoice counts
  const finalChartData = allMonths.map(month => {
    const found = chartData.find(data => data.month === month.month)
    return {
      month: month.month,
      invoice_count: found ? found.invoice_count : 0, // Use the count from chartData or 0 if not found
    }
  })

  //set  empty data if no approved invoices are found
  const options = {
    data: finalChartData.some(item => item.invoice_count > 0) ? finalChartData : [], // Use empty data if no invoices
    series: [
      {
        xKey: "month",
        yKey: "invoice_count",
        yName: "Number of Approved Invoices",
        type: "bar", // Specify the chart type as bar
        barWidth: 30, // Set the width of each bar
      },
    ],
    axes: [
      {
        type: "category",
        position: "bottom",
      },
      {
        type: "number",
        position: "left",
      },
    ],
    legend: {
      enabled: true, // Enable the legend if needed
    },
    padding: {
      left: 40,
      right: 40,
    },
  }

  return (
    <div className="min-h-screen">
      {loading && <Loader />}
      {refresh ? (
        <SessionExpired />
      ) : (
        <>
          <Header />

          <div className="flex main-body ">
            <div className=" hidden md:block">
              <Sidenav />
            </div>
            <div className="content md:w-[80%] w-full md:ml-[20%] lg:w-[86%] lg:ml-[14%] p-3 mt-[70px]">
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-3">
                <div
                  className="bg-white border-t-2 border-[#b32f4e] rounded-lg p-3 cursor-pointer hover:bg-slate-50"
                  onClick={() => {
                    navigate("/approval/all")
                  }}
                >
                  <Vector1 />
                  <p className="my-3 text-base">All Invoices</p>
                  <p className="criteria-value font-bold">
                    <NumericFormat
                      value={allInvoicesCount}
                      displayType={"text"}
                      thousandSeparator={true}
                      decimalSeparator="."
                    />
                  </p>
                </div>
                <div
                  className="bg-white border-t-2 border-[#c86406] rounded-lg p-3 cursor-pointer hover:bg-slate-50"
                  onClick={() => {
                    navigate("/approval/pending")
                  }}
                >
                  <Vector3 />
                  <p className="my-3 text-base">Pending Invoices</p>
                  <p className="criteria-value font-bold">
                    <NumericFormat
                      value={pendingInvoicesCount}
                      displayType={"text"}
                      thousandSeparator={true}
                      decimalSeparator="."
                    />
                  </p>
                </div>
                <div className="bg-white rounded-lg border-t-2 border-[#33bc6c] p-3 hover:bg-slate-50 flex flex-row items-center justify-between">
                  <div className="">
                    <ApprovedIcon />
                    <p className="my-3 text-base">Treated Invoices</p>
                    <p className="criteria-value font-bold">
                      <NumericFormat
                        value={completedInvoicesCount}
                        displayType={"text"}
                        thousandSeparator={true}
                        decimalSeparator="."
                      />
                    </p>
                  </div>

                  <div className="flex flex-col items-center justify-center gap-3">
                    <div
                      className="bg-white border-l-2 pl-2 border-[#d9534f] cursor-pointer"
                      onClick={() => {
                        navigate("/approval/declined")
                      }}
                    >
                      <p className="text-base">Declined</p>
                      <p className="criteria-value">
                        <NumericFormat
                          value={rejectedInvoicesCount}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalSeparator="."
                        />
                      </p>
                    </div>
                    <div
                      className="bg-white border-l-2 pl-2 border-[#5bc0de] cursor-pointer"
                      onClick={() => {
                        navigate("/approval/approved")
                      }}
                    >
                      <p className="text-base">Approved</p>
                      <p className="criteria-value">
                        <NumericFormat
                          value={acceptedInvoicesCount}
                          displayType={"text"}
                          thousandSeparator={true}
                          decimalSeparator="."
                        />
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div class="request-charts__container box-shadow bg-white my-4 px-4 rounded-lg">
								<p className="font-semibold text-base pt-4">Invoice chart</p>
								<p className="text-[#696969] mt-2 mb-6 text-base">
									Total Invoices approved over time
								</p>
								<AgCharts options={options} />
							</div> */}
              <div className="box-shadow bg-white my-4">
                <TableCommponnent
                  data={pendingInvoices}
                  recent_invoice={true}
                  onButtonClick={handleButtonClick}
                  total={total}
                  count={count}
                  size={size}
                  page={page}
                />
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Homepage
